import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=31510532&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31510532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31510532')) {
      api.createRecord('31510532', component.options)
    } else {
      api.reload('31510532', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=31510532&scoped=true", function () {
      api.rerender('31510532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/Breadcrumb.vue"
export default component.exports